<template>
  <div class="axj-register">
    <div class="axj-register-top">
      <div class="axj-register-top-bk" @click="handleToLogin">
        <div class="axj-register-top-icon">
        </div>
        <div class="axj-register-top-label" @click="toLogin">
          <label>
            返回
          </label>
        </div>
      </div>
      <div class="axj-register-top-title">
        <label>
          完善信息
        </label>
      </div>
    </div>
    <div class="axj-register-body">
      <div class="axj-register-body-item-avatar">
        <axj-upload
          @success="uploadSuccess"
          tips="请上传头像"
          :pre-view-file-url="axjUploadConf.preViewFileUrl"/>
      </div>
      <div  class="axj-register-body-item-normal">
        <div class="axj-register-body-item-input">
          <el-input ref="nickName" placeholder="昵称"  v-model="certForm.nickName"></el-input>
        </div>
      </div>
      <div ref="nickNameMessage" class="axj-register-body-item-normal-message">
       <div class="axj-register-body-item-normal-message-label">
         <label>{{messages.nickName.message}}</label>
       </div>
      </div>
      <div ref="school" class="axj-register-body-item-cascad">
        <div class="axj-register-body-item-input-cascader">
          <el-cascader
            clearable
            v-model="schoolAcademys"
            placeholder="请选择院校"
            :options="educationalInstitutions"
            :props="educationalInstitutionProps"
            @visible-change="handleExpandSchool"
          ></el-cascader>
        </div>
      </div>
      <div ref="schoolMessage" class="axj-register-body-item-cascad-message">
        <div class="axj-register-body-item-cascad-message-label">
          <label>{{messages.school.message}}</label>
        </div>
      </div>
      <div class="axj-register-body-item-submit">
        <div class="axj-register-body-item-button">
          <button @click="register">完成</button>
        </div>
      </div>
    </div>
    <div class="axj-register-bottom">
      同意<label>用户协议</label>与<label>隐私政策</label>
    </div>
    <axj-message-prop
      :dialog-show.sync="axjMessagePropData.dialogShow"
      :button-data="axjMessagePropData.buttonData"
      :dialog-message="axjMessagePropData.dialogMessage"
      :dialog-title="axjMessagePropData.dialogTitle"
      :handle-func="axjMessagePropData.handleFunc"
    />
  </div>
</template>

<script>
import commonModels from '@/common/models/common-models'
export default {
  name: "axj-register",
  props:{
    phone:{
      type:String,
      default:""
    },
    //短信验证码
    code:{
      type:String,
      default:""
    },
    wxUnionId:{
      type:String,
      default:""
    }
  },
  data(){
    return{
      axjUploadConf:{
        preViewFileUrl:undefined
      },
      certForm:{
        nickName:undefined,
        avatar:undefined
      },
      queryFormSchool:{
        pageData:{
          page: 1,
          limit: 10,
          total:10
        }
      },
      queryFormAcademys:{
        pageData:{
          page: 1,
          limit: 10,
          total:10
        }
      },
      schoolAcademys:[],
      educationalInstitutions:[

      ],
      educationalInstitutionProps:{
        lazy:true,
        lazyLoad:this.handleExpandAcademys,
        multiple:false
      },
      axjMessagePropData:{
        dialogShow:false,
        buttonData:[
          {
            "label":"去认证",
            "key":"yes",
            "type":""
          },
          {
            "label":"取消",
            "key":"cancel",
            "type":"primary"
          }
        ],
        handleFunc:function (){
        },
        dialogMessage:undefined,
        dialogTitle:"提示"
      },
      messages:{
        nickName:{
          message:"请填写昵称",
        },
        school:{
          message:"请选择院校",
        }
      }
    }
  },
  methods:{
    toLogin(){
      this.$emit("to-login")
    },
    initUserInfo(){
      this.$api.commonApi.commonIndex.getUserInfo({uuid: this.$store.getters.getLoginInfo.uuid}).then(res => {
        if (res.code == 200) {
          this.userInfo = res.data
          this.$store.dispatch('saveLoginInfo', {
            uuid: this.$store.getters.getLoginInfo.uuid,
            access_token: this.$store.getters.getLoginInfo.access_token,
            refresh_token:this.$store.getters.getLoginInfo.refresh_token,
            userId: res.data.id
          });
          if (this.userInfo.is_third_party == 0) {
            this.$api.axjWebApi.webAuth.QueryMechanismAuths({
              UserId:this.userInfo.id
            }).then(res=>{
              if(res.data==null||res.data.lists.Status==2){
                this.axjMessagePropData.dialogShow=true
                let that=this
                this.axjMessagePropData.handleFunc=function (v) {
                  if(v==='yes'){
                    that.$router.push({
                      path:"/certification"
                    })
                  }else if('cancel'===v){
                    that.axjMessagePropData.dialogShow=false
                  }
                }
                this.axjMessagePropData.dialogMessage="尊敬的 "+this.userInfo.nickname+"，您尚未进行机构用户认证，无法使用机构用户管理平台，是否去认证？"
              }else if (res.data.lists.Status==0){
                this.axjMessagePropData.buttonData=[{
                  "label":"取消",
                  "key":"cancel",
                  "type":"primary"
                }]
                let that=this
                this.axjMessagePropData.handleFunc=function (res) {
                  if(res==='cancel'){
                    that.axjMessagePropData.dialogShow=false
                  }
                }
                this.axjMessagePropData.dialogShow=true
                this.axjMessagePropData.dialogMessage="尊敬的 "+this.userInfo.nickname+"您已于"+commonModels.formatTime(res.data.lists.CreateTime,'Y年M月D日')+"提请机构用户认证，平台会在7个工作日内完成审核，请您耐心等待！"
              }
            })
          }else{
            this.$store.dispatch("saveUser",
              {
                uid:this.userInfo.id,
                uname:this.userInfo.nickname,
                avatar:this.userInfo.avatar,
                extraShowClubUid:this.userInfo.ExtraShowclubUser.id,
                schoolId:this.userInfo.school_id,
                infoUserUid:this.userInfo.InfoUser.id,
                info:this.userInfo
              })
            this.$router.push({
              path:"/axjMain"
            })
          }
        }
      })
    },
    register(){
      if(!this.certForm.nickName){
        this.$refs.nickNameMessage.style.visibility="visible"
        return
      }
      if(!this.schoolAcademys[0]){
        this.$refs.schoolMessage.style.visibility="visible"
        return
      }
      this.$api.commonApi.commonIndex.register({
        nickName: this.certForm.nickName,
        avatar:this.certForm.avatar,
        phone:this.phone.replace(/[^\d]/g,""),
        school_id:this.schoolAcademys[0],
        academy_id:this.schoolAcademys[1]
      }).then(res=>{
        if(res.code==200){
          this.$refs.nickNameMessage.style.visibility="hidden"
          this.$refs.schoolMessage.style.visibility="hidden"
          //注册成功 绑定微信
          if(this.wxUnionId) {
            let doLogin=true
            //unionId
            this.$api.axjWebApi.webIndex.BindingWechat({
              UserId: res.data.id,
              UnionId: this.wxUnionId
            }).then(res => {
              if (res.code == 200) {
               this.$message({
                 type:"success",
                 message:"绑定成功！"
               })
               doLogin=false
              }
            }, error => {
            })
          }
          //重新登录
          this.$api.commonApi.commonIndex.doLogin({
            identifier:this.phone.replace(/[^\d]/g,""),
            credential:this.code,
            type:"phone",
            device:'pc'
          }).then(res=>{
            if(res.code==200){
              // this.$common.startLoading().then(res=>{
              //   this.$router.push({
              //     path:"/axjMain"
              //   })
              // })
              this.initUserInfo()
            }
          },error=>{

          })
          return
        }else if(res.code==10013){
          this.$refs.nickNameMessage.style.visibility="visible"
          this.messages.nickName.message="昵称重复换一个试试？"
        }
      },error=>{
      })
    },
    handleExpandAcademys(node, resolve){
      this.$api.commonApi.commonIndex.listAcademys({
        ...this.queryFormAcademys.pageData,
        where:JSON.stringify({
          school_id:node.value
        })
      }).then(res=>{
        const nodes=[]
        let academysList=res.data.lists;
        for(let x=0;x<academysList.length;x++){
          let academy={
            label:academysList[x].name,
            value:academysList[x].id,
            leaf:true
          }
          nodes.push(academy)
        }
        resolve(nodes)
      },error=>{

      })
    },
    handleExpandSchool(show){
      if(show){
        this.$api.commonApi.commonIndex.listSchool({
          ...this.queryFormSchool.pageData
        }).then(res=>{
          let schoolList=res.data.lists;
          for(let x=0;x<schoolList.length;x++){
            let educationalInstitution={
              label:schoolList[x].name,
              value:schoolList[x].id
            }
            this.educationalInstitutions.push(educationalInstitution)
          }
        })
      }
    },
    uploadSuccess(res){
      this.axjUploadConf.preViewFileUrl=res.url
      this.certForm.avatar=res.url.substring(31,res.url.length)
    },
    handleToLogin(){
      this.$emit("to-login")
    }
  }
}
</script>

<style lang="scss" slot-scope>
.dd{
  background-color: #3a8ee6;
  font-size: 100px;
}
.axj-register {
  display: flex;
  flex-flow: column;
  height: 400px;
  .axj-register-top {
    display: flex;
    justify-content: center;
    align-items: center;

    .axj-register-top-bk:hover {
      color: #3a8ee6;

      .axj-register-top-icon {
        border-top-color: #3a8ee6;
        border-left-color: #3a8ee6;
      }
    }

    .axj-register-top-bk {
      width: 60px;
      margin-left: 2px;
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #8C8C8C;
      z-index: 0;
      cursor: pointer;

      .axj-register-top-icon {
        width: 12.5px;
        height: 12.5px;
        border-top: 2px solid #8C8C8C;
        border-radius: 2px;
        border-left: 2px solid #8C8C8C;
        transform: rotate(-45deg);
      }
    }

    .axj-register-top-title {
      flex: 1;
      font-size: 22px;
      display: flex;
      color: #000000;
      margin-left: -65px;
      justify-content: center;
      align-items: center;
      font-family: PingFang SC;
      font-style: normal;
    }
  }
  .axj-register-body{
    .axj-register-body-item-avatar{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;
      button{
        border: none;
        background:none;
        outline:none;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #F5F7FA;
        cursor: pointer;
        background-size: cover;
      }
    }

    .axj-register-body-item-normal{
      display: flex;
      justify-content: center;
      align-items: center;
      .axj-register-body-item-input{
        .el-input__inner{
          padding: 0;
          padding-left: 5px;
        }
        width: 80%;
        input{
          color: #000000;
          border: none;
          background:none;
          outline:none;
          border-bottom: 1px solid #DCDFE6;
          width: 100%;
          font-family: PingFang SC;
          font-style: normal;
          font-size: 18px;
          height: 45px;
          border-radius: 0;
        }
        input::-webkit-input-placeholder{
          color: #b5b6bc;
        }
        input:focus{
          border-bottom-color: #00ADB5;;
        }
      }

    }
    .axj-register-body-item-normal-message{
      visibility: hidden;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      .axj-register-body-item-normal-message-label{
        label{
          font-size: 12px;
          color: red;
          margin-left: 5px;
        }
        width: 80%;
      }
    }
    .axj-register-body-item-cascad{
      display: flex;
      //margin-top: 20px;
      justify-content: center;
      align-items: center;
      .axj-register-body-item-input-cascader{
        width: 80%;
        display: flex;
        justify-content: flex-start;
        .el-cascader{
          width: 50%;
          height: 45px;
          input{
            border: none;
            font-size: 18px;
            background:none;
            outline:none;
            border-bottom: 1px solid #DCDFE6;
            border-radius: 0;
            padding-left: 3px;
          }
          input:focus{
            border-bottom-color: #00ADB5;;
          }
          input::-webkit-input-placeholder{
            font-size: 18px;
            color: #b5b6bc;
          }
        }
      }
    }
    .axj-register-body-item-cascad-message{
      visibility: hidden;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      .axj-register-body-item-cascad-message-label{
        label{
          font-size: 12px;
          color: red;
          margin-left: 5px;
        }
        width: 80%;
      }
    }
    .axj-register-body-item-submit{
      margin-top: 20px;
      justify-content: center;
      display: flex;
      align-items: center;
      .axj-register-body-item-button{
          width: 80%;
          display: flex;
          justify-content: center;
          button{
            cursor: pointer;
            border: 0;
            outline: none;
            font-size: 18px;
            height: 50px;
            border-radius: 25px;
            width: 100%;
            background: linear-gradient(to top, #85d8db 0%, #00adb5 50%);
            color: #ffffff;
          }
      }
    }
  }
  .axj-register-bottom{
    width: 100%;
    display: flex;
    margin-top: 40px;
    justify-content: center;
    label{
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/axj-web-certs/components/axj-register/index.vue